import React, { useRef } from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/layout"
import SEO from "../../components/seo"
import PropTypes from "prop-types"
import Ariane from "../../components/Ariane/ariane"
import { GalerieTitle } from "./styled-components/galerie-styled"
import {
  galerieContainer,
  galerieTitle,
  masonryGrid,
  galerieImageContainer,
} from "./styles/detailsGalerie.module.scss"
import ContentTransformer from "../../components/Transformers/content-transformer"
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox"
import { useBuildData } from "../../hooks/use-build-data"
import FinalGalerieComponent from "../../components/Home/GalerieImages/final-galerie-component"
import Masonry from "react-masonry-component"

//-----------------------QueryGraphql---------------------------//

export const query = graphql`
  query($slug: String!) {
    nodeGalerieDImages(path: { alias: { eq: $slug } }) {
      ...GalerieItem
    }
  }
`
//-----------------------QueryGraphql---------------------------//

//-----------------------Component---------------------------//

const GalerieTemplate = ({ data }) => {
  const masonry = useRef()
  const galerie = data.nodeGalerieDImages
  const themeColors = useBuildData().theme_settings.palette
  const options = {
    buttons: {
      backgroundColor: themeColors.b_color_gradients.b_dark,
      showAutoplayButton: false,
      showCloseButton: true,
      showDownloadButton: false,
      showFullscreenButton: true,
      showNextButton: true,
      showPrevButton: true,
      showThumbnailsButton: true,
    },
  }

  return (
    <FinalGalerieComponent data={galerie}>
      {({ images }) => (
        <Layout isDetail={true}>
          <SEO
            title={galerie.title}
            description={
              "Dans cette page, vous découvrez la galerie suivante : " +
              galerie.title
            }
          />
          <Ariane isListing={true} pageName={galerie.title} />
          <section className={galerieContainer}>
            <GalerieTitle className={galerieTitle}>
              {galerie.title}
            </GalerieTitle>
            {galerie.body?.processed ? (
              <ContentTransformer content={galerie.body.processed} />
            ) : galerie.body?.summary ? (
              <ContentTransformer content={galerie.body.summary} />
            ) : null}
            <div className={galerieImageContainer}>
              <SimpleReactLightbox>
                <SRLWrapper options={options}>
                  <Masonry className={masonryGrid} ref={masonry}>
                    {images}
                  </Masonry>
                </SRLWrapper>
              </SimpleReactLightbox>
            </div>
          </section>
        </Layout>
      )}
    </FinalGalerieComponent>
  )
}

//-----------------------Component---------------------------//

//-----------------------Prop-Types---------------------------//

GalerieTemplate.propTypes = {
  data: PropTypes.object.isRequired,
}

//-----------------------Prop-Types---------------------------//

export default GalerieTemplate
